import React from 'react';
import { Phone, Mail, Instagram, MapPin, Clock } from 'lucide-react';
import { Button } from './ui/button';

const Footer = () => {
  const handleCall = () => {
    window.location.href = 'tel:0650088282';
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black text-white">
      {/* CTA Section */}
      <div className="border-b border-gray-800">
        <div className="container mx-auto px-4 py-16">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              Prêt à démarrer votre projet ?
            </h2>
            <p className="text-gray-400 text-lg mb-8">
              Contactez-nous dès maintenant
            </p>
            <Button 
              onClick={handleCall}
              size="lg"
              className="bg-[#8B7355] hover:bg-[#6B5744] text-white px-10 py-6 rounded-xl font-semibold text-lg transition-all duration-300 hover:shadow-2xl hover:shadow-[#8B7355]/50 flex items-center space-x-3 mx-auto"
            >
              <Phone className="w-5 h-5" />
              <span>06 50 08 82 82</span>
            </Button>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Company Info */}
          <div>
            <div className="mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_solinopro-showcase/artifacts/we4jswbw_IMG_9185.png" 
                alt="SolinoPro Logo"
                className="h-28 w-auto object-contain"
              />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              Spécialiste de la pose de revêtements, habillage d'escaliers et finitions murales. 
              Un savoir-faire artisanal pour vos projets.
            </p>
            <a 
              href="https://www.instagram.com/solinopro?igsh=Ym5sdTN6aTh5cmlv" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-2 text-[#C9A961] hover:text-[#8B7355] transition-colors"
            >
              <Instagram className="w-5 h-5" />
              <span>@solinopro</span>
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Navigation</h4>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => scrollToSection('hero')}
                  className="text-gray-400 hover:text-[#C9A961] transition-colors"
                >
                  Accueil
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-[#C9A961] transition-colors"
                >
                  Services
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('catalogue')}
                  className="text-gray-400 hover:text-[#C9A961] transition-colors"
                >
                  Catalogue
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('realisations')}
                  className="text-gray-400 hover:text-[#C9A961] transition-colors"
                >
                  Réalisations
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Nos Services</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li>Pose de sols</li>
              <li>Carrelage & mosaïque</li>
              <li>Parquet & PVC</li>
              <li>Habillage d'escaliers</li>
              <li>Finitions murales</li>
              <li>Ajustement de portes</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li>
                <a 
                  href="tel:0650088282"
                  className="flex items-center space-x-3 text-gray-400 hover:text-[#C9A961] transition-colors group"
                >
                  <div className="w-10 h-10 rounded-full bg-gray-800 group-hover:bg-[#8B7355] flex items-center justify-center transition-colors">
                    <Phone className="w-5 h-5" />
                  </div>
                  <span>06 50 08 82 82</span>
                </a>
              </li>
              <li className="flex items-start space-x-3 text-gray-400">
                <div className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center flex-shrink-0">
                  <Clock className="w-5 h-5" />
                </div>
                <div className="text-sm">
                  <p>Lun - Ven : 8h - 18h</p>
                  <p>Sam : 9h - 12h</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-500 text-sm">
              © {new Date().getFullYear()} SolinoPro. Tous droits réservés.
            </p>
            <div className="flex items-center space-x-6 text-sm text-gray-500">
              <span>Artisan professionnel</span>
              <span>•</span>
              <span>Service de qualité</span>
              <span>•</span>
              <span>Travail soigné</span>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Bottom Line */}
      <div className="h-1 bg-gradient-to-r from-transparent via-[#C9A961] to-transparent"></div>
    </footer>
  );
};

export default Footer;
